import React from 'react';
import PropTypes from 'prop-types';

class NormalStringFormatter extends React.Component {
  static propTypes = {
    value: PropTypes.string.isRequired
  };

  render() {
    const currentString = this.props.value;
    return (
      <div style={{color: 'black', fontSize:'12px'}}>
        <div aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">
          {currentString}
        </div>
      </div>
    );
  }
}

export default NormalStringFormatter;



// WEBPACK FOOTER //
// ./src/components/NormalStringFormatter.jsx